export default "__VITE_ASSET__DpdSQJ_7__"